<template>
  <div class="inline-loader" :style="elementHeight">
    <loader-spinner v-bind="[$attrs, $props]"/>
  </div>
</template>

<script>
import LoaderSpinner from '@/components/base/loader/loader-spinner'
export default {
  name: 'base-inline-loader',
  components: { LoaderSpinner },
  inheritAttrs: false,
  props: {
    height: {
      type: [String, Number],
      default: 'auto',
      validator: (value) => {
        const numbersOnlyRegex = new RegExp('^\\d+$')
        return (numbersOnlyRegex.test(value) && Number(value) >= 70) || value === 'auto'
      }
    }
  },
  computed: {
    elementHeight () {
      return {
        height: this.$props.height + 'px'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.inline-loader {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
